import {
    EightDirectionType,
    InOutDirectionType,
    SideDirectionType,
    SwitchDirectionType,
} from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';
import {
    STTransitionSideDirectionType,
    STTransitionSpeed,
    STTransitionLeftRightDirectionType,
    STTransitionEightDirectionType,
    STTransitionInOutDirectionType,
} from '@tencent/slide-sdk-pb-model';
import { TransitionSpeed } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

export const sideDirectionSdkMapping: Record<STTransitionSideDirectionType, SideDirectionType> = {
    [STTransitionSideDirectionType.r]: SideDirectionType.RIGHT,
    [STTransitionSideDirectionType.l]: SideDirectionType.LEFT,
    [STTransitionSideDirectionType.u]: SideDirectionType.UP,
    [STTransitionSideDirectionType.d]: SideDirectionType.DOWN,
    [STTransitionSideDirectionType.PBDEFAULT]: SideDirectionType.LEFT,
};

export const switchDirectionSdkMapping: Record<STTransitionLeftRightDirectionType, SwitchDirectionType> = {
    [STTransitionLeftRightDirectionType.l]: SwitchDirectionType.LEFT,
    [STTransitionLeftRightDirectionType.r]: SwitchDirectionType.RIGHT,
    [STTransitionLeftRightDirectionType.PBDEFAULT]: SwitchDirectionType.LEFT,
};

export const eightDirectionSdkMapping: Record<STTransitionEightDirectionType, EightDirectionType> = {
    [STTransitionEightDirectionType.PBDEFAULT]: EightDirectionType.LEFT,
    [STTransitionEightDirectionType.l]: EightDirectionType.LEFT,
    [STTransitionEightDirectionType.u]: EightDirectionType.UP,
    [STTransitionEightDirectionType.r]: EightDirectionType.RIGHT,
    [STTransitionEightDirectionType.d]: EightDirectionType.DOWN,
    [STTransitionEightDirectionType.lu]: EightDirectionType.LEFT_UP,
    [STTransitionEightDirectionType.ru]: EightDirectionType.RIGHT_UP,
    [STTransitionEightDirectionType.ld]: EightDirectionType.LEFT_DOWN,
    [STTransitionEightDirectionType.rd]: EightDirectionType.RIGHT_DOWN,
};

export const slideDirectionSdkMapping: Record<STTransitionSideDirectionType, SideDirectionType> = {
    [STTransitionSideDirectionType.PBDEFAULT]: SideDirectionType.LEFT,
    [STTransitionSideDirectionType.l]: SideDirectionType.LEFT,
    [STTransitionSideDirectionType.u]: SideDirectionType.UP,
    [STTransitionSideDirectionType.r]: SideDirectionType.RIGHT,
    [STTransitionSideDirectionType.d]: SideDirectionType.DOWN,
};

export const inOutDirectionSdkMapping: Record<STTransitionInOutDirectionType, InOutDirectionType> = {
    [STTransitionInOutDirectionType.PBDEFAULT]: InOutDirectionType.OUT,
    [STTransitionInOutDirectionType.out]: InOutDirectionType.OUT,
    [STTransitionInOutDirectionType.in]: InOutDirectionType.IN,
};

export const speedSdkMapping: Record<STTransitionSpeed, TransitionSpeed> = {
    [STTransitionSpeed.med]: TransitionSpeed.MEDIUM,
    [STTransitionSpeed.fast]: TransitionSpeed.FAST,
    [STTransitionSpeed.slow]: TransitionSpeed.SLOW,
    [STTransitionSpeed.PBDEFAULT]: TransitionSpeed.DEFAULT,
};

export function invertMapping<
    T extends string | number | symbol,
    U extends string | number | symbol,
>(mapping: Record<T, U>): Record<U, T> {
    const invertedMapping = {};

    for (const key in mapping) {
        if (mapping[key]) {
            const value = mapping[key];
            (invertedMapping as Record<U, T>)[value] = key as unknown as T;
        }
    }

    return invertedMapping as Record<U, T>;
}
